import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Html from 'react-pdf-html';
import { config } from 'src/config';
import { useAppSelector } from 'src/rtk/app/hook';
import { useGetProgressReportDataQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import loader from '../../assets/images/loader.gif';

interface Props {
  userInfo: any;
  setReportId: any;
  trainingId: any;
  sessionInfo: any;
}
// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
  },
  nextLine: {
    marginTop: -20,
    textAlign: 'center',
    fontSize: '10px',
  },
});

// Create Document Component
// const MyDocument = () => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <View style={styles.section}>
//         <Text>Section #1</Text>
//       </View>
//       <View style={styles.section}>
//         <Text>Section #2</Text>
//       </View>
//     </Page>
//   </Document>
// );

export const TrainingProgressReportPDF = (props: Props) => {
  const { userInfo, setReportId, trainingId, sessionInfo } = props;

  const [imageBase64, setImageBase64] = useState('');

  const { data: list, isSuccess, isLoading } = useGetProgressReportDataQuery({
    regNo: userInfo?.registration_no,
    trainingId: trainingId
  });


  const data: any = list?.data || {};

  console.log(data);
  console.log(userInfo);

  // SOLUTION TWO FOR FETCH AND DISPLAY IMAGE IN PDF 

  const token = useAppSelector((state) => state.auth.token);

  const fetchImageBase64 = async (filepath: string) => {
    const res = await fetch(`${config.API_URL}/v1/get-image?filepath=${filepath}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`, // if needed
        'Accept': 'image/*',                    // optional
      },
    });

    const blob = await res.blob();
    const reader = new FileReader();

    return await new Promise<string>((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  useEffect(() => {
    if (data?.logbook_session?.supervisor_signature) {
      fetchImageBase64(data?.logbook_session?.supervisor_signature.replace(/^storage\//, "")).then((base64) => {
        setImageBase64(base64);
      });
    }
  }, [data?.logbook_session?.supervisor_signature]);

  let pdfUrl = '';

  const html = `  
  <html>    
    <body>
        <style>        

        .print-container{
          padding: 0 15px;
        }

        .wide-column {
          width: 500px;
          background-color: powderblue;
        }

        table {
          margin: 0px 0px;
          padding: 0px;
          border: 1px solid black;
          font-size: 12px;
        }

        table > tbody> tr > *{
          padding: 5px
        }

        table th {
          text-align: center;    
        }
        
        table td {
                
        }

        .bgColor {
          background-color: powderblue;
        }
        b {
          font-family: 'Times-Bold'; 
        }
        p {
          font-size: 14px
        }
        span {
          font-size: 14px;
        }

        .tableMargin {
          margin-top: 5px;
          margin-bottom: 5px;
        }

        .signature-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;
          margin-top: 40px;
        }
          
      </style>

      <div class="print-container"> 
        <span>(A)</span>
        <table class="tableMargin">
          <tbody>
            <tr class='bgColor'>
              <td style="width: 66px"><b>Reg. No. of BCPS:</b></td>
              <td>${userInfo?.details?.bmdc_registration_no ?? ''}</td>
              <td>Date of Submission: ${moment(data?.created_at).format('DD/MMM/YYYY') ?? ''}</td>
            </tr>
            <tr class='bgColor'>
              <td><b>Name of the Trainee:</b></td>
              <td colspan="2">${userInfo?.details?.personal_info?.full_name ?? ''}</td>
            </tr>
            <tr>
              <td class='bgColor'><b>Specialty:</b></td>
              <td colspan="2">${userInfo?.details?.subject?.subject_name ?? ''}</td>
            </tr>
            <tr>
              <td class='bgColor'><b>Enrollment/Online Reg. No:</b></td>
              <td>${userInfo?.details?.bcps_registration_no ?? ''}</td>
            </tr>
            <tr>
              <td class='bgColor'><b>Cell Phone:</b></td>
              <td>${userInfo?.details?.personal_info?.mobile ?? ''}</td>
              <td>${userInfo?.details?.personal_info?.telephone ?? ''}</td>
            </tr>
            <tr>
              <td class='bgColor'><b>Email:</b></td>
              <td>${userInfo?.details?.personal_info?.email ?? ''}</td>
            </tr>
            <tr>
              <td class='bgColor'><b>Present Workplace with Designation:</b></td>
              <td>${data?.logbook_session?.institute_name ?? ''}</td>
            </tr>
          </tbody>
        </table>
        <span>(B)</span>
        <table class="tableMargin">
        
          <tbody> 
            <tr style="background-color: rgb(106, 110, 253);">
              <td>Supervisor Certificate</td>
            </tr>
            <tr>
              <td class='bgColor'>Name of the Supervisor: </td>
              <td>${data?.logbook_session?.supervisor_name ?? ''
    }</td>
            </tr>
            <tr>
              <td class='bgColor'>Institute & Department: </td>
              <td>${data?.logbook_session ? data?.logbook_session?.institute_name + ', ' + data?.logbook_session?.department_name : ''}</td>

            </tr>
            <tr>
              <td class='bgColor'>Number of Bed in the Unit: </td>
              <td>15</td>
            </tr>
            <tr>
              <td class='bgColor'>Number of FCPS Trainee in the Unit: </td>
              <td>8</td>
            </tr>
            <tr>
              <td class='bgColor'>Number of Faculty Members 
              (Asst. Prof. or equivalent post and above) in the Unit: 
              </td>
              <td>7</td>
            </tr>
          </tbody>
        </table> 
        <span>(C)</span>
        <table class="tableMargin">
            <thead> 
              <tr style="background-color: rgb(254, 190, 177);">
                <th>Performance</th>
                <th>Poor</th>
                <th>Average</th>
                <th>Good</th>
                <th>Satisfactory</th>
                <th>Excellent</th>
              </tr>
            </thead>
            <tbody>
              <tr>
              <td style="background-color: rgb(254, 190, 177);">Attendance</td>
              <td>${data.attendance === 'Poor' ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />' : ''}</td>
              <td>${data.attendance === 'Average' ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />' : ''}</td>
              <td>${data.attendance === 'Good' ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />' : ''}</td>
              <td>${data.attendance === 'Satisfactory' ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />' : ''}</td>
              <td>${data.attendance === 'Excellent' ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />' : ''}</td>
              </tr>
              <tr>
              <td style="background-color: rgb(254, 190, 177);">Knowledge</td>
              <td>${data.knowledge === 'Poor'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.knowledge === 'Average'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.knowledge === 'Good'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.knowledge === 'Satisfactory'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.knowledge === 'Excellent'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        </tr>
                        <tr>
                        <td style="background-color: rgb(254, 190, 177);">Skill</td>
                        <td>${data.skill === 'Poor'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.skill === 'Average'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.skill === 'Good'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.skill === 'Satisfactory'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.skill === 'Excellent'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        </tr>
                        <tr>
                        <td style="background-color: rgb(254, 190, 177);">Attitude</td>
                        <td>${data.attitude === 'Poor'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.attitude === 'Average'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.attitude === 'Good'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.attitude === 'Satisfactory'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
                        <td>${data.attitude === 'Excellent'
      ? '<img src="/images/Picture1.png" style="width: 20px; margin-left: 25px;" />'
      : ''
    }</td>
              </tr>
            </tbody>
          </table>
          <span style="margin-top: 20px;">
            Supervisor’s Comment: ${data?.supervisor_comment ?? ''}<br/>
            Supervisor’s Recommendation: Considering his/her overall performance I recommend that the trainee <u>${data?.supervisor_recommendation ?? ''}</u> proceed for further training.
          </span>

          <div class="signature-box">
            <img src="${imageBase64}" style="width: 120px; height: 30px; margin-bottom: 0px;" />
            <div>.............................</div>
            <span>Supervisor Signature</span>
          </div>
      </div>      
    </body>
  </html>
`;

  // const MyDocument = (
  //   <Document>
  //     <Page size="A4" style={styles.page}>
  //       <View style={styles.section}>
  //         <Text>Section #1</Text>
  //       </View>
  //       <View style={styles.section}>
  //         <Text>Section #2</Text>
  //       </View>
  //     </Page>
  //   </Document>
  // );

  const MyDocument = (
    <Document>
      <Page size="A4">
        <View style={styles.row}>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '10px',
            }}
          />
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '14px',
              margin: '20px',
              marginBottom: '0px',
            }}
          >
            BANGLADESH COLLEGE OF PHYSICIANS AND SURGEONS (BCPS)
          </Text>
        </View>
        <Text style={styles.nextLine}>
          67, Shaheed Tajuddin Ahmed Sarani, Mohakhali, Dhaka-1212
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica-Bold',
            fontSize: '14px',
            margin: '15px',
          }}
        >
          FCPS Part-II Training Progress Report
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica-Bold',
            fontSize: '12px',
          }}
        >
          Period:{' '}
          {moment(sessionInfo?.session_start_date).format('DD/MMM/YYYY') ?? ''} to{' '}
          {moment(sessionInfo?.session_end_date).format('DD/MMM/YYYY') ?? ''}
        </Text>
        <Html>{html}</Html>
      </Page>
    </Document>
  );

  useEffect(() => {
    if (isSuccess && imageBase64) {
      const pdfData = pdf(MyDocument).toBlob();
      pdfData.then((pdfData) => {
        const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfContent);
        pdfUrl = url;
        setReportId('');
        window.open(pdfUrl, '_blank');
      });
    }
  }, [isSuccess, imageBase64]);

  return (
    <div>
      <div>
        {isLoading ? (
          <div className="overlay">
            <img src={loader} alt="Loading" height={100} width={300} />
          </div>
        ) : null}
      </div>
    </div>
  );
};
